import { useContext, useEffect, useState } from "react"
import { config } from "../context/config";
import '../style/pages/employees.css'

import Jobs from '../data/jobs.json';
import { action } from "../context/action";
import { recodeNow, update } from "../components/indexDB/indexDBStora";
import { ValidationEmployee } from "../funcs/validation/ValidationEmployee";
import TableEmp from "../components/empPage/tableEmp";
import { switchh } from "../context/switch";
import Expenses from "../components/empPage/expensesEmp";
import { CurrentTime } from "../funcs/current";
import WorkForce from "../components/empPage/WorkForce";
import { useLocation } from "react-router-dom";
import {Link} from 'react-router-dom';
import { collection } from "../context/collect";
import { auth } from "../context/auth";
import { intialData } from "../context/initial";
import { useTransaction } from "../funcs/hooks/usetransaction";
import { useTranslation } from "react-i18next";

export default function Employees () {
    const { t } = useTranslation();
    const {stylingNav} = useContext(config);
    const {errorMessage, setErrorMessage, editMode, setEditMode} = useContext(action);
    const { employee, setEmployee } = useContext(collection);
    const { initializeEmp } = useContext(intialData);
    const {setLoadingProcess} = useContext(switchh);
    const [Route, setRoute] = useState("");
    const { user } = useContext(auth);

    // record transactions
    const record_transaction = useTransaction("record", `تسجيل موظف جديد على السيستم بأسم ${employee.fullName}`);
    const update_transaction = useTransaction("update", `تم تعديل بيانات الموظف التالي ${employee.fullName} - ${employee.code}`);

    const location = useLocation();
    useEffect(() => {
        const Path = location.pathname.split("/")[2];
        setRoute(Path);
    }, [location.pathname])
    
    const EmpAction = async (mode="record") => {
        const result = await ValidationEmployee(employee, mode, t);
        if(!result || !result.status) {
            setErrorMessage(result.message);
            return;
        }
        setErrorMessage("");

        if(mode === "modify") {
            result.data.meta.updatedAt.push(CurrentTime());
            await update("employees", result.data);
            await recodeNow(update_transaction.data, "transactions");
            setEditMode(false);      
        }
        else {
            result.data.meta.createdAt.date = CurrentTime();
            await recodeNow(result.data, "employees");
            await recodeNow(record_transaction.data, "transactions");
        }
        setEmployee(initializeEmp);
        setLoadingProcess(false)
    }

    const Reset = () => {
        setEditMode(false);
        setEmployee(initializeEmp);
    }

    return (
        <div className={`employees page ${!stylingNav ? "page-grow" : "page-shrink"}`}>
            <h2 className="text-weight-light">{t("sections:HR.full")}</h2>
            <div className="container">
                <form onSubmit={(e) => {
                    e.preventDefault();
                    EmpAction()
                }} className="">
                    <div className="flex"> 
                        <div className="child job">
                                <label>{t("label:employee.jobTitle.label")}</label>
                                <select
                                    value={employee.job}
                                    onChange={(e) =>
                                        setEmployee(prev => ({
                                            ...prev,
                                            user: employee.job !== "pilot" ? "" : employee.user,
                                            password: employee.job !== "pilot" ? "" : employee.password,
                                            job: e.target.value,
                                            salary: { type: "", value: "" }
                                        }))
                                    }
                                >
                                    <option disabled value="">{t("label:employee.jobTitle.chooseJob")}</option>
                                    {Jobs.map((e, i) => (
                                        <option key={i} value={e.job}>{t(`jb:${e.job}`)}</option>
                                    ))} 
                            </select>
                            <small>{t("common:employee.roleJobAuth")} <Link to={'/help/jobEmp'}>{t("common:clickHere")}</Link></small>
                        </div>
                        <div className="child name">
                            <label>{t("label:employee.fullName")}</label>
                            <input
                            value={employee.fullName} onChange={(e) => setEmployee((prev)=>({...prev, fullName: e.target.value}))} type="text" placeholder={t("placeholder:employee.fullName")} />
                            <small>{t("common:employee.displayInInvoice")}</small>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="child user">
                            <label>{t("auth:user")}</label>
                            <input
                            disabled={employee.job === "pilot" || editMode}
                            value={employee.user} maxLength={8} onChange={(e) => setEmployee((prev)=>({...prev, user: e.target.value}))} type="text" placeholder={t("placeholder:employee.username")}/>
                        </div>
                        <div className="child pass">
                            <label>{t("auth:pass")}</label>
                            <input
                            disabled={employee.job === "pilot"}
                            value={employee.password} maxLength={8} onChange={(e) => setEmployee((prev)=>({...prev, password: e.target.value}))} type="password" placeholder={t("placeholder:employee.password")} />
                        </div>
                    </div>
                    <div>
                        <div className="flex">
                            <div className="child address">
                                <label>{t("label:employee.address")}</label>
                                <input
                                value={employee.details.address}
                                maxLength={40}
                                onChange={(e) => 
                                    setEmployee((prev)=>({...prev, details: {...prev.details, address:  e.target.value}}))} 
                                type="text" placeholder={t("placeholder:employee.address")} />
                            </div>
                            <div className="child phone">
                                <label>{t("label:employee.phoneNumber")}</label>
                                <input
                                min={0}
                                value={employee.details.phone}
                                onChange={(e) => 
                                    setEmployee((prev)=>({...prev, details: {...prev.details, phone:  e.target.value}}))}  
                                type="number" placeholder={t("placeholder:employee.phoneNumber")} />
                            </div>
                        </div>
                        <div className="flex">
                            <div className="child typeSal">
                                <label>{t("label:employee.salaryType.label")}</label>
                                <select value={employee.salary.type} onChange={(e) => {
                                    const value = e.target.value;
                                    if(value === "perOrder") employee.salary.value = "";
                                    setEmployee((prev) => ({...prev, salary: {...prev.salary, type: value}}))
                                }}>
                                    <option value="" selected disabled>{t("label:employee.salaryType.chooseSal")}</option>
                                    <option value='perMonth'>{t("salarySystem:monthly")}</option>
                                    {employee.job === "pilot" ? 
                                    <>
                                        <option value='perHour'>{t("salarySystem:byHour")}</option>
                                        <option value='perOrder'>{t("salarySystem:byOrder")}</option>
                                    </>
                                    :
                                    <option value='perDay'>{t("salarySystem:daily")}</option>
                                    }
                                </select>
                            </div>
                            <div className="child sala">
                                <label>{t("label:employee.salary")}</label>
                                <input type="number" placeholder={t("placeholder:employee.salary")}
                                min={1}
                                value={employee.salary.value}
                                disabled={employee.salary.type === "perOrder"}
                                onChange={(e) => setEmployee((prev) => ({...prev, salary: {...prev.salary, value: e.target.value}}))} />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-align-item-center">
                        <div className="child status">
                            <label>{t("common:status")}</label>
                            <select value={employee.status} onChange={(e) => setEmployee((prev)=>({...prev, status: e.target.value}))}>
                                <option disabled selected value={''}>{t("label:employee.StatusEmp")}</option>
                                <option value={true}>{t("label:employee.status.active")}</option>
                                <option value={false}>{t("label:employee.status.deactive")}</option>
                            </select>
                        </div>
                        <div className="child code">
                            <label>{t("common:code")}</label>
                            <input type="text" placeholder={t("placeholder:employee.code")}
                                value={employee.code}
                                disabled={editMode}
                                maxLength={4}
                                onChange={(e) => setEmployee((prev) => ({...prev, code: e.target.value}))} 
                            />
                        </div>
                    </div>
                    <p className="error">{errorMessage}</p>
                    <div className="record-emp">
                        {editMode ? 
                            <>
                            <button type="button" onClick={() => EmpAction("modify")} className="normal-bg">{t("action:employee.edit")}</button>
                            <button type="button" onClick={() => Reset()} className="error text-weight-bold">x</button>
                            </>
                            :
                            <button className="success-bg">{t("action:employee.NewRecord")}</button>
                        }
                    </div>
                </form>
                <div className="table">
                    <h3>{t("common:employees")}</h3>
                    <TableEmp />
                </div>
            </div>
            <div className="container flex">
                <div className="exp half">
                    <h3>{t("common:expenses")}</h3>
                    <Expenses path={Route} currency={user.data[0]?.currency.code} />
                </div>
                <div className="half">
                    <h3>{t("common:employee.manageSchedule.label")}</h3>
                    <WorkForce path={Route} />
                </div>
            </div>
        </div>
    )
}